import { UsuarioModel } from 'projects/core/src/lib/core/model/UsuarioModel';
import { ResponseModel } from 'projects/core/src/lib/core/model/ResponseModel';
import { ThrowError } from 'projects/core/src/lib/core/ThrowError';
import { BoasVindasDialog } from './boas-vindas.dialog';
import { TratamentoGatewayService } from 'projects/core/src/lib/core/TratamentoGatewayService';
import { UsuarioProvider } from 'projects/core/src/lib/core/provider/UsuarioProvider';
import { AppSession } from 'projects/core/src/lib/core/AppSession';

export class BoasVindasViewModel {

    constructor() {}

    usuarioModel = new UsuarioModel()
    usuarioProvider = new UsuarioProvider()
    context: BoasVindasDialog

    async processoBoasVindas() {
        let retorno = await this.usuarioProvider.boasVindas();
        try {
            retorno = new TratamentoGatewayService(this.getContext()).builder(retorno)
            if (retorno.status == ResponseModel.STATUS_OK) {
                this.salvaBoasVindasLocal(retorno.data)
            } else {
                throw new Error(ThrowError.MESSAGE_DEFAULT)
            }
        } catch (e) {}
    }

    setContext(context: BoasVindasDialog) {
        this.context = context
    }

    getContext(): BoasVindasDialog {
        return this.context
    }

    async salvaBoasVindasLocal(usuario: UsuarioModel) {
        AppSession.saveUser(usuario)
    }
}